<button type="button" class="hts-assistant-history-link" *ngIf="isVisible" (click)="open()">
  <span class="hts-assistant-history-link__icon">
    <img src="assets/icons/hts-history.svg" alt="" />
  </span>
  <span class="hts-assistant-history-link__text">{{ "HTS_ASSISTANT.HISTORY_LINK" | translate }}</span>
  <i class="fa fa-chevron-right hts-assistant-history-link__chevron" aria-hidden="true"></i>
</button>
